import { render } from "./MovementRow.vue?vue&type=template&id=5b6e56ea&scoped=true&ts=true"
import script from "./MovementRow.vue?vue&type=script&lang=ts"
export * from "./MovementRow.vue?vue&type=script&lang=ts"

import "./MovementRow.vue?vue&type=style&index=0&id=5b6e56ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6e56ea"]])

export default __exports__